// 3rd party libs
import React from 'react';
import cx from 'classnames';

// local imports
import styles from './Avatar.module.scss';

type TAvatar = {
  avatar?: string | undefined | null;
  border?: string;
  className?: string;
  name?: string;
  onClick?: (e?: any) => void;
};

const Avatar: React.FC<TAvatar> = ({ avatar, border = 'none', className, name, onClick }) => {
  const classes = className ? cx(styles.avatar, className) : styles.avatar;

  return (
    <div onClick={onClick}>
      {avatar ? (
        <div className={classes} style={{ backgroundImage: `url(${avatar})`, border }} />
      ) : (
        <div className={cx(classes, styles.withoutImg)} style={{ border }}>
          <span>{name && name.trim()[0].toLocaleUpperCase()}</span>
        </div>
      )}
    </div>
  );
};

export default Avatar;
